"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("CustomSelectListModal", _vm._b({
    attrs: {
      "list-columns": _vm.createColumns(0),
      "modal-columns": _vm.createColumns(1),
      valid: _vm.valid
    },
    on: {
      "update:valid": function ($event) {
        _vm.valid = $event;
      },
      change: _vm.handleChange
    },
    scopedSlots: _vm._u([_vm.$scopedSlots.extra ? {
      key: "extra",
      fn: function () {
        return [_vm._t("extra")];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.selectedRowKeys,
      callback: function ($$v) {
        _vm.selectedRowKeys = $$v;
      },
      expression: "selectedRowKeys"
    }
  }, "CustomSelectListModal", _vm.$props, false));
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;